import React from 'react';
import FactorTabLayout from '../shared/FactorTabLayout';
import { getTab } from '../config';

/**
 * Quantitative tightening impact analysis.
 *
 * Currently the shared factor layout with nothing extra. Add tab-specific
 * sections as children of FactorTabLayout - they stay isolated to this file.
 */
const QtPressureTab = ({ data, period }) => (
  <FactorTabLayout tab={getTab('qt')} data={data} period={period} />
);

export default QtPressureTab;
